import React from 'react';
import magazineCirculation from '../assets/images/magazineCirculation.png';
import { Link } from 'react-router-dom';
import diagWhiteDx from '../assets/graphics/diagonal_white_dx.png';
import diagWhiteSxReverse from '../assets/graphics/diagonal_white_sx_reverse.png';
import { useSelector } from 'react-redux'

const Home_AboutUs = () => {

    const isIta = useSelector((state) => state.createUser.languageIta);

    return (
        <div className='text-light' >

            <div className='myBgTransparentLight' style={{ backgroundImage: `url(${diagWhiteDx})`, height: "100px", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "100% 100%" }}></div>

            <div className='spacerLg myBgWhite'>{/* adaptive spacer */}</div>
            {/* part 1 */}
            <div className='myBgWhite text-dark d-flex justify-content-center pb-5'>
                <div className='p-3 pt-5 text-center pb-5' style={{ maxWidth: "900px" }}>
                    <h1 className='display-5 fw-bold myTextAcqua'>{isIta ? "AIUTIAMO L'INDUSTRIA A CONNETTERSI" : "WE HELP THE INDUSTRY CONNECT"}</h1>
                    {
                        isIta ?
                            <h3 className='fw-light pt-5'><b>La missione di Infodent</b> è creare servizi altamente specializzati e su misura per le esigenze del cliente. Una comunicazione multicanale pensata per incrementare il business delle imprese.  </h3>
                            : <h3 className='fw-light pt-5'><b>Infodent</b> mission is to create tailored-made and highly specialized services. A multichannel communication designed to increase your business.  </h3>
                    }
                </div>
            </div>
            {/* video youtube */}
            <div className='myBgWhite pb-5'>
                <div className=' d-flex justify-content-center'>
                    <div className='ratio ratio-16x9 myMaxWidth1000'>
                        <iframe width="560" height="315" referrerpolicy="strict-origin-when-cross-origin" src="https://www.youtube-nocookie.com/embed/4p3BOsq-RpY?si=7C7mfgfjwmFkcg1j" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
            <div className='myBgWhite text-dark d-flex justify-content-center py-5'>

                <div className='p-2 px-3' style={{ maxWidth: "900px" }}>
                    {
                        isIta ?
                            <h2><b>Infodent</b> è un’Agenzia di Marketing ed una casa editrice specializzata nel <b>B2B e B2C</b>. Forniamo servizi globali a 360° nel settore <b>Dentale</b> e <b>Medicale</b>. </h2>
                            : <h2><b>Infodent</b>, since 1994, has been a Marketing Agency and Publishing House specialized in both <b>B2B & B2C</b> sectors. We provide comprehensive 360° global services within the <b>Dental</b> and <b>Medical</b> industries. </h2>
                    }
                    {
                        isIta ?
                            <h3 className='fw-light pt-5'>Creiamo <b>connessioni</b> efficaci tra distributori e produttori.</h3>
                            : <h3 className='fw-light pt-5'>We create effective <b>connections</b> between distributors and manufacturers.</h3>
                    }
                    <Link className='noDecoration' to={"/ourstrategy"}><div className='d-flex align-items-baseline text-primary myCursor' ><p className='fw-bold'>{isIta ? "La nostra Strategia" : "Our Strategy"} </p><i className="bi bi-caret-right-fill ms-2"></i></div></Link>
                </div>
            </div>



            <div className='myBgDarkgray' style={{ backgroundImage: `url(${diagWhiteSxReverse})`, height: "100px", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "100% 100%" }}></div>

            {/* part 2 */}
            <div>
                <div className='myBgDarkgray' style={{ height: "100px", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "100% 100%" }}>
                    <div className='d-flex justify-content-center'>
                        <div className='p-2 px-3 text-center' style={{ maxWidth: "700px" }}>
                            <h1>{isIta ? "Le nostre riviste dentali e medicali sono distribuite in tutto il mondo" : "Our Dental & Medical Magazines are distributed Worldwide"}</h1>
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-center myBgDarkgray py-5'>
                    <img className='w-100' src={magazineCirculation} alt="" style={{ maxWidth: "1000px" }} />
                </div>
            </div>

            {/* part 3 */}
            <div className='myBgWhite text-dark'>
                <div className='myBgDarkgray' style={{ backgroundImage: `url(${diagWhiteDx})`, height: "100px", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "100% 100%" }}></div>
                <div >
                    <div className='d-flex justify-content-center'>
                        <div className='p-2 px-3' style={{ maxWidth: "700px" }}>
                            <h1 className='display-4 fw-bold myTextFucsia'>{isIta ? "Non è abbastanza?" : "Not enough?"}</h1>
                            <h2 className='fw-light text-center'>{isIta ? "Ecco cosa facciamo:" : "Here's all we do:"}</h2>
                        </div>
                    </div>
                </div>
                <div className=' p-3 d-flex justify-content-center'>
                    <div style={{ maxWidth: "700px" }}>

                        <div className='my-5'>
                            <div className='d-flex align-items-center gap-3'>
                                <i className="myFontSize42 bi bi-airplane-fill myTextFucsia" ></i>
                                {
                                    isIta ?
                                        <h4><b>Infodent</b> accompagna i propri clienti nella partecipazione alle più importanti <b>fiere di settore</b>, offrendo un supporto completo in ogni fase.</h4>
                                        : <h4><b>Infodent</b> supports its clients in participating in the most important <b>industry trade shows</b>, providing comprehensive support at every stage.</h4>
                                }
                            </div>
                            {
                                isIta ?
                                    <p className="myFontSize22 text-secondary"><i>Con i nostri servizi di <b>co-esposizione</b> vi assicuriamo massima visibilità e uno stand davvero sotto i riflettori, sia nel settore <b>medicale</b> che in quello <b>dentale</b>. </i></p>
                                    : <p className="myFontSize22 text-secondary"><i>Through our <b>co-exhibition</b> services, we ensure maximum visibility and place your stand firmly in the spotlight, across both the <b>medical</b> and <b>dental</b> sectors. </i></p>
                            }
                        </div>
                        <div className='text-end mb-5'>
                            <div className='d-flex align-items-center justify-content-end gap-3'>
                                {
                                    isIta ?
                                        <h4><b>Infodent</b> affianca le aziende nello sviluppo di <b>strategie di marketing</b> su misura, costruite intorno a obiettivi, mercato di riferimento e posizionamento.</h4>
                                        : <h4><b>Infodent</b> partners with companies to develop tailored <b>marketing strategies</b>, built around their goals, target markets, and positioning.</h4>
                                }
                                <i className="myFontSize42 bi bi-wrench-adjustable myTextFucsia" ></i>
                            </div>
                            {
                                isIta ?
                                    <p className="myFontSize22 text-secondary"><i>Grazie a <b>strumenti digitali avanzati</b>, a un <b>team di giornalisti professionisti</b> e a oltre <b>30 anni di esperienza</b> nel settore, siamo pronti a dare nuovo impulso al vostro <b>business</b> e ad amplificarne la <b>visibilità</b>. </i></p>
                                    : <p className="myFontSize22 text-secondary"><i>Leveraging <b>advanced digital tools</b>, a <b>team of professional journalists</b>, and over <b>30 years of industry experience</b>, we are ready to drive new momentum for your <b>business</b> and amplify its <b>visibility</b>.</i></p>
                            }
                        </div>
                        <div className='mb-5'>
                            <div className='d-flex align-items-center gap-3'>
                                <i className="myFontSize42 bi bi-arrow-through-heart-fill myTextFucsia" ></i>
                                {
                                    isIta ?
                                        <h4><b>Infodent</b> permette ai produttori di entrare direttamente negli <b>studi odontoiatrici e nei laboratori</b>, creando un contatto reale e mirato con i <b>professionisti</b> del settore.</h4>
                                        : <h4><b>Infodent</b> enables manufacturers to connect directly with <b>dental practices and laboratories</b>, creating meaningful and targeted engagement with <b>industry professionals</b>.</h4>
                                }
                            </div>
                            {
                                isIta ?
                                    <p className='myFontSize22 text-secondary'><i>Attraverso il nostro principale canale di comunicazione <b>italiano B2C</b>, i nostri clienti possono raggiungere direttamente il cliente finale, ottenendo risultati concreti e misurabili. </i></p>
                                    : <p className='myFontSize22 text-secondary'><i>Through our primary <b>Italian B2C</b> communication channel, our clients can connect directly with end customers, achieving tangible and measurable results.</i></p>
                            }
                        </div>
                        <div className='text-end mb-5'>
                            <div className='d-flex align-items-center justify-content-end gap-3'>
                                {
                                    isIta ?
                                        <h4><b>Infodent</b> assiste aziende ed associazioni dentali ad organizzare e gestire i loro eventi.</h4>
                                        : <h4><b>Infodent</b> assist Dental Companies & Associations to organize and manage their events.</h4>
                                }
                                <i className="myFontSize42 bi bi-flag-fill myTextFucsia" ></i>
                            </div>
                            {
                                isIta ?
                                    <p className="myFontSize22 text-secondary"><i>Infodent mette al vostro servizio <b>strategie di marketing, tecnologie avanzate e solide competenze organizzative</b>, trasformando la vostra visione commerciale in un evento di successo. </i></p>
                                    : <p className="myFontSize22 text-secondary"><i><b>Infodent</b> brings together <b>marketing strategies, advanced technologies, and solid organizational expertise</b> to transform your commercial vision into a successful, results-driven event.</i></p>
                            }
                        </div>

                    </div>
                </div>
            </div>


        </div >
    )
}

export default Home_AboutUs